export default __webpack_public_path__ + "static/media/dev1.0d53b438.png";